import { Button, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { Size } from '../../hooks/useModal'
import { AlertBase } from '../../components/_WMS/Alert/AlertBase'
import { DateTime } from 'luxon'
import { useApi } from '../../hooks/useApi'
import { WorkOrderOutbound } from '../../interfaces/WorkOrderOutbound'
import { ApiResponse } from '../../typings/ApiResponse'
import { Status } from '../../hooks/useFetchState'
import { Filter } from '../../components/_WMS/FilterComponent'
import { getInventoryCheck } from './api'
import { eInventoryCheckState } from '../../enums/eInventoryCheck'
import { validatePermittedRoleButton } from '../../utils/validateRoleHelper'
import { cfgRoleButton } from '../../configurationButton'

interface WorkOrderOutboundButtonBarProps {
  isPriorizing: boolean
  selectedElement: number[]
  setIsPriorizing: (value: React.SetStateAction<boolean>) => void
  handleSearch: (filters: Filter[], page?: number, pageSize?: number) => void
  onClickMassiveTagModification: (psize?: Size) => void
  onClickCreateInventoryCheck: (psize?: Size) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
}

const overdueFilters = () => {
  const elements = getInventoryCheckStatesFilter(
    [eInventoryCheckState.Creada, eInventoryCheckState['En Proceso']]
  )

  return [
    {
      key: 'initialPromiseDate',
      value: DateTime.utc(1970, 1, 1).toFormat('yyyy-MM-dd'),
      label: 'Fecha Compromiso Desde',
      displayValue: DateTime.utc(1970, 1, 1).toFormat('yyyy-MM-dd')
    },
    {
      key: 'finalPromiseDate',
      value: DateTime.local().toFormat('yyyy-MM-dd'),
      label: 'Fecha Compromiso Hasta',
      displayValue: DateTime.local().toFormat('yyyy-MM-dd')
    },
    ...elements
  ]
}

const forTodayFilters = () => {
  const todayStart = DateTime.local().startOf('day').toFormat('yyyy-MM-dd')
  const todayEnd = DateTime.local().endOf('day').toFormat('yyyy-MM-dd')

  const elements = getInventoryCheckStatesFilter(
    [eInventoryCheckState.Creada, eInventoryCheckState['En Proceso']]
  )

  return [
    {
      key: 'initialPromiseDate',
      value: todayStart,
      label: 'Fecha Compromiso Desde',
      displayValue: todayStart
    },
    {
      key: 'finalPromiseDate',
      value: todayEnd,
      label: 'Fecha Compromiso Hasta',
      displayValue: todayStart
    },
    ...elements
  ]
}

const getInventoryCheckStatesFilter = (
  validStates: number[]
) => {
  return validStates.map((inventoryCheckStateId) => ({
    key: 'inventoryCheckStateId',
    value: inventoryCheckStateId.toString(),
    label: 'Estado',
    displayValue:
        eInventoryCheckState[inventoryCheckStateId] || ''
  }))
}

export const InventoryCheckButtonBar: React.FC<WorkOrderOutboundButtonBarProps> =
  ({
    isPriorizing,
    setIsPriorizing,
    selectedElement,
    onClickMassiveTagModification,
    onClickCreateInventoryCheck,
    setSelectedFilters
  }) => {
    const { state: StateTodayAlert, callApi: StateTodayAlertCallApi } =
      useApi<ApiResponse<WorkOrderOutbound>>()

    const { state: StateOverdueAlert, callApi: StateOverdueAlertCallApi } =
      useApi<ApiResponse<WorkOrderOutbound>>()

    const requestOverdueWorkOrderOutbound = (filters: Filter[]) => {
      StateOverdueAlertCallApi(getInventoryCheck(filters))
    }
    const requestTodayWorkOrderOutbound = (filters: Filter[]) => {
      StateTodayAlertCallApi(getInventoryCheck(filters))
    }

    useEffect(() => {
      requestOverdueWorkOrderOutbound(overdueFilters())
      requestTodayWorkOrderOutbound(forTodayFilters())
    }, [])

    return (
      <Grid container justifyContent='center' spacing={2}>
        <Grid container item xs={12} md={4} spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <AlertBase
              status='error'
              title={'Atrasadas'}
              count={StateOverdueAlert.data?.totalItems || 0}
              countDescription='OTs'
              loading={StateOverdueAlert.status === Status.Loading}
              onClick={() =>
                setSelectedFilters(overdueFilters())
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <AlertBase
              status='warning'
              title={'Para hoy'}
              count={StateTodayAlert.data?.totalItems || 0}
              countDescription='OTs'
              loading={StateTodayAlert.status === Status.Loading}
              onClick={() =>
                setSelectedFilters(forTodayFilters())
              }
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} md={8} spacing={3} justifyContent='flex-end'>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          ></Grid>

        {validatePermittedRoleButton(cfgRoleButton.btnInventoryCheck_Create) && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          >
             <Button
              fullWidth
              variant='contained'
              color='primary'
              size='small'
              onClick={() => onClickCreateInventoryCheck('md')}
            >
              Crear Orden
            </Button>
          </Grid>
        )}
        {validatePermittedRoleButton(cfgRoleButton.btnInventoryCheck_EditTag) && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          >
            <Button
              disabled={selectedElement.length === 0}
              fullWidth
              variant='contained'
              color='primary'
              size='small'
              onClick={() => onClickMassiveTagModification('sm')}
            >
              Modificar TAG
            </Button>
          </Grid>
        )}
        {validatePermittedRoleButton(cfgRoleButton.btnInventoryCheck_Priorization) && (
          <Grid
            item
            xs={12}
            lg={3}
            justifyContent='flex-end'
            alignContent='flex-end'
            alignItems='flex-end'
          >
            {!isPriorizing && (
              <Button
                fullWidth
                variant='contained'
                color='primary'
                onClick={() => setIsPriorizing(true)}
                size='small'
              >
                Priorizar
              </Button>
            )}
            {isPriorizing && (
              <Button
                fullWidth
                variant='contained'
                color='primary'
                onClick={() => setIsPriorizing(false)}
                size={'small'}
              >
                Terminar Priorización
              </Button>
            )}
          </Grid>
        )}
        </Grid>
      </Grid>
    )
  }
